import React from 'react';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { FiltersWrapper } from 'components/Dashboards/Portfolio/phasePerformance/components/filtersWrapper';
import { PhasePerformance } from 'components/Dashboards/Portfolio/phasePerformance/components/phasePerformance';
import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';

export const PhasePerformancePage = () => {
    useFullStoryPageView({ pageName: portfolioConfig.phasePerformance.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={portfolioConfig.phasePerformance.title} />
                    <FiltersWrapper />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <PhasePerformance />
            </MainContent>
        </PageContainer>
    );
};
